import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { validatePassword } from "../../../utils/general";
import { changePassword } from "../../../action/password";
import customConfig from "../../../config";
import Dialog from "../../Common/Dailog/Dailog";
import FormInput from "../../Common/FormInputs/MuiTextField";
import AppButton from "../../Common/Button/Button";

const ChangePassword = ({ open, onClose, changePassword: changePasswordAction }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const formMaxWidth = 360;

  const submitPassword = () => {
    setError("");
    if (!newPassword || !confirmPassword) {
      setError("Please fill both fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    const { valid, error: validationError } = validatePassword(newPassword);
    if (!valid) {
      setError(validationError);
      return;
    }
    changePasswordAction(newPassword)
      .then(() => {
        setNewPassword("");
        setConfirmPassword("");
        onClose();
      })
      .catch(() => {
        setError(customConfig.passwordChangeError);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitPassword();
  };

  const handleCancel = () => {
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
  };

  const fieldSx = {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    "& .MuiInputLabel-root": {
      overflow: "visible",
      lineHeight: 1.4375,
    },
    "& .MuiOutlinedInput-root": {
      overflow: "visible",
    },
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      title="Change Password"
      titleSx={{ pl: { xs: 3, sm: 5.25 }, pr: 3 }}
      maxWidth="xs"
      fullWidth
      closeOnBackdropClick
      closeOnEscapeKeyDown
      contentSx={{
        overflow: "visible",
        pt: 3,
        pb: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          maxWidth: { xs: "100%", sm: formMaxWidth },
          mx: "auto",
          minWidth: 0,
          pt: 0.5,
        }}
      >
        <input
          type="text"
          name="username"
          autoComplete="username"
          value=""
          onChange={() => {}}
          tabIndex={-1}
          aria-hidden="true"
          style={{
            position: "absolute",
            width: 1,
            height: 1,
            opacity: 0,
            pointerEvents: "none",
          }}
        />
        <FormInput
          label="New Password"
          type="password"
          name="newPassword"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          fullWidth
          size="small"
          autoFocus
          sx={fieldSx}
        />
        <FormInput
          label="Confirm New Password"
          type="password"
          name="confirmPassword"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          fullWidth
          size="small"
          sx={fieldSx}
        />
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            width: "100%",
            minWidth: 0,
            pt: 0.5,
          }}
        >
          <AppButton variant="ghost" size="medium" onClick={handleCancel}>
            Cancel
          </AppButton>
          <AppButton variant="primary" size="medium" onClick={submitPassword}>
            Submit
          </AppButton>
        </Box>
      </Box>
    </Dialog>
  );
};

ChangePassword.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  changePassword: (newPassword) => dispatch(changePassword(newPassword)),
});

export default connect(null, mapDispatchToProps)(ChangePassword);
